import { FullPageAuth } from '@kitopi-com/customer-auth';
import { useTranslation } from 'react-i18next';
import downloadAppArImg from '../../assets/images/download-app-ar.webp';
import downloadAppEnImg from '../../assets/images/download-app-en.webp';
import { HeroSectionWrapper } from './HeroSectionWrapper';
import { SuccessContainerWrapper } from './SuccessContainerWrapper';

export const SuccessPage = () => {
  const { i18n } = useTranslation('wifi');
  const downloadAppImg = i18n.resolvedLanguage === 'ar' ? downloadAppArImg : downloadAppEnImg;

  return (
    <FullPageAuth
      heroSection={{
        mobile: (
          <HeroSectionWrapper
            imageSrc={downloadAppImg}
            imageAlt="Download App"
            imageWidth="70%"
            isSignedIn={true}
          />
        ),
        tabletPortrait: (
          <HeroSectionWrapper
            imageSrc={downloadAppImg}
            imageAlt="Download App"
            imageWidth="50%"
            isSignedIn={true}
          />
        ),
        tabletLandscape: (
          <HeroSectionWrapper
            imageSrc={downloadAppImg}
            imageAlt="Download App"
            imageWidth="100%"
            isSignedIn={true}
          />
        ),
        desktop: (
          <HeroSectionWrapper
            imageSrc={downloadAppImg}
            imageAlt="Download App"
            imageWidth="100%"
            isSignedIn={true}
          />
        ),
      }}
      successContainer={{
        mobile: <SuccessContainerWrapper titleFontSize="28px" />,
        tabletPortrait: <SuccessContainerWrapper titleFontSize="36px" />,
        tabletLandscape: <SuccessContainerWrapper titleFontSize="36px" />,
        desktop: <SuccessContainerWrapper titleFontSize="36px" />,
      }}
    />
  );
};
